import {use} from 'react';

import {ConditionUploadContext} from '../contexts/ConditionUploadContext';
import {TConditionUploadContext} from '../types/TConditionUploadContext';

export const useConditionUploadContext = (): TConditionUploadContext => use(ConditionUploadContext);
